import { Dispatch, SetStateAction } from 'react'

import { WidgetChoice } from '@/common/util/choice'
import { ChildProps } from '@/common/util/props'
import { SearchConditionBase } from '@/common/util/search'

import RadioButtonElement from '@/components/view/atoms/radio/RadioButtonElement'
import DisclosureSortButton from '@/components/view/molecules/disclosure/DisclosureSortButton'

interface Props<T> extends ChildProps {
  name: string
  currentValue: string | number | boolean | null
  choices: WidgetChoice<string | number | boolean | null>[]
  setCondition: Dispatch<SetStateAction<T>>
}

const DisclosureSortRadioSelect = <T extends SearchConditionBase>({
  children,
  name,
  currentValue,
  choices,
  setCondition
}: Props<T>) => {
  return (
    <DisclosureSortButton
      disclosureNode={
        <>
          {choices.map((choice, index) => (
            <RadioButtonElement
              key={index}
              name={choice.name}
              value={index}
              checked={currentValue === choice.value}
              onChange={() => {
                setCondition((condition) => {
                  return {
                    ...condition,
                    page: 1,
                    [name]: choice.value
                  }
                })
              }}
              label={choice.name}
              forDisclosure
            />
          ))}
        </>
      }
      quantity={currentValue || currentValue != null ? 1 : undefined}
      onClickDelete={
        currentValue != null
          ? () => {
              setCondition((condition) => ({
                ...condition,
                page: 1,
                [name]: null
              }))
            }
          : undefined
      }
    >
      {children}
    </DisclosureSortButton>
  )
}

export default DisclosureSortRadioSelect
